import getPayload from './utils/getPayload';

export default getPayload();



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/payload.js
 **/